module.exports = __webpack_public_path__ + "img/jiuzhang-back-three@3x.a354feeb.jpg";